<template>
  <div class="row container mt-5">
    <vx-card title="Cache(AWS Parameter Store)">
      <vs-input
        name="storeKey"
        v-model="storeKey"
        :error="hasError('storeKey')"
        v-validate="'required'"
        label="Parameter store key"
        placeholder="RDS-redgirasol-cluster"></vs-input>

      <template slot="footer">
        <vs-button
          @click="purgeCache"
          :disabled="isValidForm()">
          Purgar cache
        </vs-button>
      </template>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: "ConfigCache",
  data: () => ({
    storeKey: null
  }),
  methods: {
    async purgeCache() {
      this.$vs.loading();
      try {
        await axios.post('/api/config/cache/refresh', {
          store_key: this.storeKey
        })
        swal(
            'Notificación',
            `El parámetro de configuración ${this.storeKey} ha sido eliminado de cache correctamente`,
            'success'
        )
      } finally {
        this.$vs.loading.close();
      }
    },
    hasError(storeKey) {
      return this.errors.has(storeKey);
    },
    isValidForm() {
      return this.errors.count() > 0;
    }
  }
}
</script>

<style scoped>

</style>
